import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { HomeworkRoutingModule } from './homework.routing';
import { HomeworkComponent } from './homework.component';
import { ValidationService } from '../form-validation/validation.service';
import { HomeworkService } from './homework.service';

@NgModule({ declarations: [
        HomeworkComponent
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        HomeworkRoutingModule], providers: [ValidationService, HomeworkService, provideHttpClient(withInterceptorsFromDi())] })

export class HomeworkModule { }
